<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>
                Benefit
            </template>
            <template v-slot:pageDetail>
                List
            </template>
        </o-bread-crumb>
        <div v-if="validation" class="alert alert-danger mt-3">
            {{ validation }}
        </div>

        <!-- Feature Disabled State -->
        <div v-if="!isBenefitModuleEnabled" class="feature-disabled-container mt-4">
            <div class="disabled-content">
                <i class="fas fa-toggle-off fa-3x primary-text mb-3"></i>
                <h4>Benefit Module Disabled</h4>
                <p>The Benefit Module has been disabled by System Administration. Please contact System Owner to enable this feature.</p>
            </div>
        </div>

        <template v-if="isBenefitModuleEnabled">
        <div v-if="thisComponentShow" class="card text-center mt-3">
            <div class="card-header">
                <ul class="nav nav-pills card-header-pills  justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">
                            <a class="nav-link text-dark fs-4" href="#">List of Benefits</a>
                        </div>
                    </li>
                    <li class="nav-item btn btn-primary btn-sm" v-if="write">
                        <router-link :to="{ name: 'BenefitForm' }" class="nav-link text-white">Add new Benefit
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="card-body">
            <div class="d-flex justify-content-center spinner-border text-primary spinner-position" v-if="page.isLoading"></div>
            <div class="spinner" v-if='page.isLoading'></div>
            <div class="" v-if="page.output">
                <!-- <div class="d-flex d-inline-block">
                    <div class="form-group" v-if="selectedBusinessProfile.merchant_id == '' || selectedBusinessProfile.merchant_id == null">
                        <label for="">Merchant id</label>
                        <o-select v-model="selectMerchant" :options="merchants" autocomplete="'off'"></o-select>
                    </div>
                </div> -->
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">                                
                            <o-search :searchOptions="searchOptions" @submit="search" @clear="clearSearch"></o-search>
                        </div>
                    </li>
                    <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">                                
                        <li class="nav-item btn btn-primary btn-sm">
                            <button class="reload nav-link text-white" @click.prevent="load_state()">&#x21bb;</button>
                        </li>
                    </ul>
                </ul>
                <o-table style="text-align:left;" class="table-hover">
                    <thead>
                        <tr>
                            <td class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                                {{ field }}
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                            <tr v-for="(item, index) in benefits" :key="index">
                            <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div>{{ item.id.slice(0, 9) + '...' }}</div>
                                </div>
                            </td>
                            <td>{{ item.name }}</td>
                            <!-- <td>
                                <div class="d-flex align-items-center">
                                    <div>{{ item.merchant_name}}</div>
                                </div>
                            </td> -->
                            <td>{{ item.tier_names || 'All Tiers' }}</td>
                            <td class="ml-3">
                                <div class="d-flex">
                                    <div class="me-1" v-if="write">
                                        <router-link class="btn btn-sm btn-info rounded-pill text-white" :to="{ name: 'BenefitEdit', params: { id: item.id } }">Edit
                                        </router-link>
                                    </div>
                                    <div v-if="write">
                                        <button class="btn btn-sm btn-danger rounded-pill text-white border-0" @click.prevent="promptDelete(item)">Delete
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="benefits.length === 0">
                            <td colspan="5" class="text-center">No benefits available</td>
                        </tr>
                    </tbody>
                </o-table>
            </div>
            </div>
            
            <div class="container mt-5">
                <o-pagination :page="meta.page"  :total="meta.total" @callback="navPage"/>
            </div>
        </div>

        <o-warning-box
            v-if="showDeleteModal"
            title="Delete Benefit"
            :item-name="selectedItem?.name || 'this benefit'"
            warning-message="This action cannot be undone."
            confirm-text="Yes, Delete"
            cancel-text="Cancel"
            @confirm="confirmDelete"
            @cancel="showDeleteModal = false"
        />

        <toast-notification :toasts="toasts" @remove="removeToast" />
        </template>
    </div>
    <br>

</template>

<script>

import store from '@/store/'
import {mapState} from 'vuex'
import {OTable, OPagination, OBreadCrumb, OSearch, OWarningBox } from '@/components/OmnihControl'
import ToastNotification from '@/components/member/ToastNotification.vue'
import { useToast } from '@/composables/useToast'
import { computed, onMounted, reactive, ref, watch, onBeforeUnmount } from 'vue'

export default {
    setup() {
        const { toasts, showToast, removeToast } = useToast();
        let lastActivePage = 1;

        let meta = computed(() => store.state.Benefit.meta)

        let page = reactive({
            isLoading: false,
            output: false,
            component: 'benefit'
        });

        let fields = ref([
            'No',
            'Id',
            'Name',
            // 'Merchant',
            'Tier',
            'Action'
        ]);

        const validation = ref('');

        const thisComponentShow = ref(true);

        const isBenefitModuleEnabled = computed(() => {
            return (store.state.FeatureFlag?.benefitModule?.flag || 'ACTIVE') === 'ACTIVE'
        });

        const showDeleteModal = ref(false);
        const selectedItem = ref(null);

        const merchants = ref([]);

        const selectMerchant = ref();

        const selectedBusinessProfile = reactive({
            branch_id: '',
            merchant_id: '',
            corporate_id: ''
        });

        const voucherSearch = ref([]);

        const selectVoucher = ref();

        const searchBy = reactive({
            selected:"code",
            criteria:"",
            date_start: "",
            date_end: ""
        })

        const searchOptions = reactive([
            { value: 'name', text: 'name' },
        ])

        const selfLoaded = ref(store.state.Auth.selfLoaded);

        const write = ref(false);

        watch(
            () => store.state.Auth.selfLoaded,
            (newVal) => {
                if (newVal) {
                    selfLoaded.value = newVal;
                    loadSelectedBusinessProfile();
                }
            }
        );

        onMounted(() => {
            store.commit('Benefit/reset_meta');

            if (selfLoaded.value) {
                loadSelectedBusinessProfile();
            }
        });

        onBeforeUnmount(() => {
            const updatedMeta = { ...meta.value, page: lastActivePage };
            store.commit('Benefit/switch_page', { meta: updatedMeta });

            store.commit('Benefit/clear_search');
            store.dispatch('Benefit/read').then(() => {});
        });

        function load_state(){
            page.isLoading = true;

            store.dispatch('Benefit/read')
            .then(function(){})
            .catch((err) => console.error(err))
            .finally(()=>{
                page.isLoading = false;
                page.output=true;
            });
            if (store.state.Auth.currUser.level === 'root') {
                write.value = true;
            } else {
                const userModules = store.state.Auth.userInfo.modules;

                if (userModules) {
                    const matchingModule = userModules.find(module => module.module_name === page.component);
                    write.value = matchingModule ? matchingModule.write : false;
                } else {
                    console.error('userModules is undefined');
                    write.value = false;
                }
            }
        }

        function promptDelete(item) {
            selectedItem.value = item;
            showDeleteModal.value = true;
        }

        function confirmDelete() {
            if (!selectedItem.value) return;
            const itemId = selectedItem.value.id;
            const itemName = selectedItem.value.name;
            showDeleteModal.value = false;
            page.isLoading = true;

            store.dispatch('Benefit/delete', itemId)
                .then(() =>{ 
                    showToast({
                        type: 'success',
                        title: 'Deleted Successfully',
                        message: `Benefit "${itemName}" has been successfully deleted.`
                    });
                    load_state();
                }).catch((err) => {
                    console.error(err.data);
                    showToast({
                        type: 'error',
                        title: 'Delete Failed',
                        message: err.response?.data?.message || err.message || 'There was an error deleting this benefit.'
                    });
                }).finally(() => {
                    page.isLoading = false;
                    selectedItem.value = null;
                });
        }

        function navPage(page){
            const _meta = {... meta.value, page}
            store.commit('Benefit/switch_page',{meta:_meta})
            load_state()
        }

        async function loadSelectedBusinessProfile() {
            await store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
                selectedBusinessProfile.branch_id = businessProfile.branch_id;
                selectedBusinessProfile.merchant_id = businessProfile.merchant_id;
                selectedBusinessProfile.corporate_id = businessProfile.corporate_id;

                if (businessProfile.merchant_id) {
                    selectMerchant.value = businessProfile.merchant_id;
                } else {
                    if (businessProfile.branch_id) {
                        selectMerchant.value = businessProfile.branch_id;
                    } else if (businessProfile.corporate_id) {
                        selectMerchant.value = businessProfile.corporate_id;
                    } else {
                        selectMerchant.value = "all";
                    }
                    loadMerchants();
                }
            }).finally(() => load_state());
        }

        function getBenefitImage(item) {
            if (item.media_type === 'default' && item.default_image_url) {
                return item.default_image_url;
            } else if (item.avatar && item.avatar.image_url) {
                return item.avatar.image_url;
            }
            return null;
        }

        function loadMerchants() {
            const filter = {
                branch_id: selectedBusinessProfile.branch_id,
            }

            store.commit('Merchant/add_filter', {filter});
            store.dispatch('Merchant/read').then(() => {
                merchants.value = [{value: "all", text: "From all merchant"}, ...store.state.Merchant.merchants.map((merch)=>({'value':merch.id,'text':merch.name}))]
            })
        }

        function search(searchBy){
            const {selected, criteria, date_start, date_end} = searchBy;

            if (selected) {
                let search = {}

                if (criteria && selected !== 'created_at'){
                    search[selected] = criteria;
                }else if(date_start && date_end){
                    search[selected] = `${date_start}, ${date_end}`;
                }

                const updatedMeta = { ...meta.value, page: 1 };
                store.commit('Benefit/switch_page', { meta: updatedMeta });

                store.commit('Benefit/set_search', {search});
                store.dispatch('Benefit/read').then(() => {});
            }

        }

        function clearSearch(){
            const updatedMeta = { ...meta.value, page: lastActivePage };
            store.commit('Benefit/switch_page', { meta: updatedMeta });

            store.commit('Benefit/clear_search');
            store.dispatch('Benefit/read').then(() => {});
        }

        watch(
            () => selectMerchant.value,
            (newVal) => {
                let filter;
                
                if (newVal === "all") {
                    filter = { branch_id: selectedBusinessProfile.branch_id };
                } else if (selectedBusinessProfile.merchant_id && newVal === selectedBusinessProfile.merchant_id) {
                    filter = { merchant_id: newVal };
                } else if (selectedBusinessProfile.branch_id && newVal === selectedBusinessProfile.branch_id) {
                    filter = { branch_id: newVal };
                } else if (selectedBusinessProfile.corporate_id && newVal === selectedBusinessProfile.corporate_id) {
                    filter = { corporate_id: newVal };
                } else {
                    filter = { branch_id: selectedBusinessProfile.branch_id };
                }

                store.commit('Benefit/add_filter', {filter});
                store.dispatch('Benefit/read').then()
                .catch((err) => {
                    console.error(err)
                    validation.value = err.response.data.message;
                    thisComponentShow.value = false;
                })
                .finally(() => page.output = true);
            }
        )

        return {
            page,
            fields,
            load_state,
            meta,
            navPage,
            selectedBusinessProfile,
            merchants,
            selectMerchant,
            search,
            clearSearch,
            voucherSearch,
            selectVoucher,
            searchBy,
            searchOptions,
            validation,
            thisComponentShow,
            write,
            selfLoaded,
            showDeleteModal,
            selectedItem,
            promptDelete,
            confirmDelete,
            toasts,
            removeToast,
            isBenefitModuleEnabled,
            getBenefitImage
        }
    },
    computed: {
        ... mapState({
            benefits: state => state.Benefit.benefits,
            searchBy: state => state.Benefit.search
        }),
    },
    components:{
        OTable,
        OPagination,
        OBreadCrumb,
        OSearch,
        OWarningBox,
        ToastNotification
    }
}
</script>

<style scoped>
.list-thumbnail-container {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid #e2e8f0;
}

.list-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.list-thumbnail-placeholder {
    color: #94a3b8;
    font-size: 16px;
}

    .form-group {
        width: 250px;
        text-align: left;
        padding-left: 16px;
    }

    /* Feature Disabled State */
    .feature-disabled-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 400px;
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        padding: 2rem;
    }

    .disabled-content {
        text-align: center;
        color: #6b7280;
    }

    .disabled-content h4 {
        color: #374151;
        margin-bottom: 0.5rem;
        font-weight: 600;
    }

    .disabled-content p {
        margin: 0;
        font-size: 0.95rem;
    }
</style>